import Mock from 'mockjs';
Mock.mock('/api/user/login', {
    "status": 0,
    "data": {
        "id|1001-1100": 0,
        "username": "@cname",
        "email": "@email",
        "phone|1-9": 0,
        "role": 0,
        "createTime": 1524545121218,
        "updateTime": 1524545121218
    }
});

Mock.mock("/dev/general-service/v1/service/delivery/detail","post", 
    { code: '00', 
        body: [
            {
                id: 1,
                deliveryId: 1,
                orderCode: '4133110-A01',
                appartmentCode: '4133110-A01',
                appartmentName: "后组合灯总成（右）",
                unit: '件',
                boxType: '纸箱',
                inCount: 40,
                deliveredBoxCount: 40,
                deliveredCount: 40,
                batchNumber: 1524545121218,
                recieveCount: 38,
                preArriveDate: 1524545121218,
                deliveryDetailType: 'E0',
                remark:'ET0试制订单为正式订单',
            },
            {
                id: 2,
                deliveryId: 1,
                orderCode: '4133110-A01',
                appartmentCode: '4133110-A01',
                appartmentName: "后组合灯总成（右）",
                unit: '件',
                boxType: '纸箱',
                inCount: 40,
                deliveredBoxCount: 40,
                deliveredCount: 40,
                batchNumber: 1524545121218,
                recieveCount: 38,
                preArriveDate: 1524545121218,
                deliveryDetailType: 'E0',
                remark:'ET0试制订单为正式订单',
            }
        ]
    }
);

Mock.mock("/dev/general-service/v1/service/delivery/list", "post", ()=>{
    return { code: '00', 
        body: [
            {
                id: 1,
                ASNCode:"BQQD-CG-KZET0-DQ-0041",
                projectName:"微卡/小卡项目",
                supplierCode:"BQQD-CG-KZET0-DQ-0041",
                supplierName:"丹阳市新联汽车配件有限公司",
                deliveryAddress: '山东省莱西市姜山镇昌庆路北京汽车制造厂',
                deliveryDate : 1524545121218,
                recieveyDate : 1524545121218,
                ASNStatus: '已发货',
            },
            {
                id: 2,
                ASNCode:"BQQD-CG-KZET0-DQ-0041",
                projectName:"微卡/小卡项目",
                supplierCode:"BQQD-CG-KZET0-DQ-0041",
                supplierName:"丹阳市新联汽车配件有限公司",
                deliveryAddress: '山东省莱西市姜山镇昌庆路北京汽车制造厂',
                deliveryDate : 1524545121218,
                recieveyDate : 1524545121218,
                ASNStatus: '已发货',
            } 
        ]
    }
});

Mock.mock("/dev/general-service/v1/service/delivery/delete", "post", ()=>{
    return{ code: '00', 
        body: []
    }
});